import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Checkbox from "./Checkbox";
import Style from "style-it";
import SearchField from "../common/SearchField";
import "react-toastify/dist/ReactToastify.css";
import Scrollbar from "react-scrollbars-custom";
import instance from "../../axios";

const buildList = (value) => {
  const list = {};
  if (value && value.length) {
    value.forEach((id) => {
      list[id] = true;
    });
  }
  return list;
};

const filterCities = (source, text) => {
  const query = (text || "").toLowerCase();
  if (!query) return source || [];
  return (source || []).filter((item) =>
    (item.name || "").toLowerCase().includes(query)
  );
};

const CitySelector = (props) => {
  const logInUser = useSelector((state) => state.logInUsers);
  const allCitiesRef = useRef([]);
  const searchRef = useRef("");
  const [list, setList] = useState(() => buildList(props.value));
  const [search, setSearch] = useState("");
  const [cities, setCities] = useState([]);
  const valueKey = Array.isArray(props.value) ? props.value.join(",") : "";

  useEffect(() => {
    setList(buildList(props.value));
  }, [valueKey]);

  useEffect(() => {
    if (!logInUser?.id) return undefined;
    let cancelled = false;
    instance({
      method: "GET",
      url: "/api/citys/get?limit=-1",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (cancelled) return;
        const raw = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
          ? res.data
          : [];
        allCitiesRef.current = raw.map((item) => ({
          ...item,
          name: item.cityEn || item.name || item.region || item.label,
        }));
        setCities(filterCities(allCitiesRef.current, searchRef.current));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [logInUser?.id]);

  const onChange = (event, city) => {
    const next = { ...list };
    if (event.target.checked) {
      next[city.id] = true;
    } else {
      delete next[city.id];
    }
    setList(next);
    if (props.onChange) {
      props.onChange(Object.keys(next), "city");
    }
  };

  const searchItem = (event) => {
    const text = event.target.value;
    searchRef.current = text;
    setSearch(text);
    setCities(filterCities(allCitiesRef.current, text));
  };

  return (
    <Style>
      {`
        .selector-list li > label.active,
        .selector-list li > label:hover {

        }
        .selector-list li {
            margin-bottom: 6px
        }
        .selector-list li > label {
            cursor: pointer;
            display: block;
            padding: 2px 6px;
            border-radius: 4px;
            display: flex;
            align-items: center;
        }
        .selector-list {
            padding: 0;
            margin: 0;
            list-style: none
        }
        .selector-label {
            font-size: 12px;
            line-height: 1.5;
            margin-left: 6px;
        }
        .selector-check {
            height: 26px;
            display: inline-flex;
            align-items: center;
        }
        .selector-count {
            padding: 0 0 6px;
            font-size: 10px
        }`}
      <div>
        <div
          className="section-head clearfix section-head-filter"
          style={{ padding: 0, marginLeft: -6, marginRight: -2 }}
        >
          <ul className="filter-row pull-left">
            <li>
              <SearchField
                label={props.translate("searchCity")}
                type="search"
                placeholder="exp: ID, Name"
                value={search}
                onChange={searchItem}
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </li>
          </ul>
        </div>
        <div className="selector-count">
          {Object.keys(list).length} {props.translate("city")}
        </div>
        <Scrollbar
          disableTracksWidthCompensation={true}
          style={{
            height:
              (props.minHeight ? parseInt(props.minHeight) : 35) *
              (props.rows || 5),
          }}
          scrollerProps={{
            renderer: (scrollProps) => {
              const { elementRef, ...restProps } = scrollProps;
              return <div {...restProps} ref={elementRef} id="scrollableDiv" />;
            },
          }}
        >
          <ul className="selector-list">
            {cities.map((row) => (
              <li key={row.id}>
                <label>
                  <span className="selector-check">
                    <Checkbox
                      checked={Boolean(list[row.id])}
                      value={row}
                      onChange={onChange}
                    />
                  </span>
                  <span className="selector-label">{row.name}</span>
                </label>
              </li>
            ))}
          </ul>
        </Scrollbar>
      </div>
    </Style>
  );
};

export default CitySelector;
